import { render, staticRenderFns } from "./coWithdrawAudit.vue?vue&type=template&id=004e0b6f&scoped=true"
import script from "./coWithdrawAudit.vue?vue&type=script&lang=js"
export * from "./coWithdrawAudit.vue?vue&type=script&lang=js"
import style0 from "./coWithdrawAudit.vue?vue&type=style&index=0&id=004e0b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e0b6f",
  null
  
)

export default component.exports